import React from 'react'

const UniversityCardView = ({cardData,title,offer}) => {
    return (
        <section className="universities-degree-in-steps">
        <div className="progress-bar-section">
            <div className="vl-progress"/>
            <span className="vl-progress-1">1</span>
            <span className="vl-progress-2">2</span>
            <span className="vl-progress-3">3</span>
            <span className="vl-progress-4">4</span>
            </div>
        <div className="university-steps-section">
            <div className="university-steps-title">{title}</div>
            <div className="university-card">
            {
                cardData.map((e,i)=>(
                    <div key={i} className="university-card-view">
                        <img src={e.image} className="university-card-view-logo"/>
                        <div key={i} className="university-card-view-content">
                        <span className="university-card-view-content-title">{e.title}</span>
                        <span className="university-card-view-content-para">{e.text}</span>
                        </div>
                    </div>
                ))
            }
            </div>  
                <div className="offer-banner">{offer}</div>
                {/* <div classname="d-flex align-items-center justify-content-center">
                    <button className="enquire-btnn2">ENQUIRE NOW</button>
                </div> */}
                <a 
                    class="btn-default institute-banner-button" 
                    href="#"
                    id="uni-card-view-btn"
                >
                    Enquire NOW
                </a>
        </div>
        
   </section>
    )
}

export default UniversityCardView
